import type { SEO, Website } from '@ps/web-martech-cms-types';
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSelector } from 'react-redux';
import URL from 'url-parse';

import { select } from '@swf/core/store';

const CMSSEO: React.FC<SEO> = ({
  meta: { title, canonical, description, keywords, robots: { noindex, nofollow } = {} }
}) => {
  const { meta_tags: metaTags } = useSelector(select.cms.getWebsite) as Website;
  const origin = useSelector(select.location.getOrigin);
  const pathname = useSelector(select.location.getPathname);
  const canonicalLink = useSelector(select.cms.getCanonicalLink);
  const href = new URL(canonical || canonicalLink || origin).set('pathname', pathname).toString();
  const pageAlternateLinks = useSelector(select.cms.getPageAlternateLinks);
  const websiteAlternateLinks = useSelector(select.cms.getAlternateLinks);
  const alternateLinks = pageAlternateLinks || websiteAlternateLinks;

  return title || description || keywords || noindex || canonicalLink || alternateLinks ? (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {noindex && <meta name="robots" content={`noindex,${nofollow ? 'nofollow' : 'follow'}`} />}
      {metaTags?.map(({ name, content }) => (
        <meta key={content} name={name} content={content} />
      ))}
      {alternateLinks?.map(({ localeCode, url }) => (
        <link key={localeCode} rel="alternate" hrefLang={localeCode} href={url} />
      ))}
      <link rel="canonical" href={href} />
    </Helmet>
  ) : null;
};
export default CMSSEO;
